<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';

   export default {
   page: {
            title: "Edit Driver",
            meta: [
               {
                  name: "description",
                  content: appConfig.description,
               },
                  ],
         },
   components: { Layout, PageHeader },
         data() {
            const current_date = moment().format("YYYY-MM-DD");
            return {
                  title: "Edit Driver",
                  items: [
                     {
                        text: "Drivers",
                        href: "/drivers",
                     },
                     {
                        text: "Edit Driver",
                        active: true,
                     },        
                           ],
            country_codes: [],
            trucks: [],
            driver: {
               country_code_id:"",
               name_en: "",
               name_so: "",
               mobile: "",
               email: "",
               password: "",
               password_confirmation: "",
               fuel_station: "",
               truck_id: "",
               license_expiry: "",
               fuel_station_name:""
                     },
            today: current_date,
            profile_image: "",
            passport_image: "",
            license_image: "",
            preview_profile_image: "",
            preview_license_image: "",
            preview_passport_image: "",
            token: "",
            errors: {},
         };
      },
      mounted() 
         {
         this.fetchCountryCodes();
          },
      created() 
         {
          this.fetchDriver();
         },
      methods: {
         numbersOnly(event) 
            {
               let keyCode = event.keyCode;
               if (keyCode < 48 || keyCode > 57)
                {
                  event.preventDefault();
                }
            }, 
         alphaSpacesOnly(event) 
            {
               let keyCode = event.keyCode;
               if ((keyCode >= 65 && keyCode <= 90) || 
                  (keyCode >= 97 && keyCode <= 122) ||               
                  (keyCode == 32)) 
                  {
                  return;
                  } else {
                        event.preventDefault();
                        }
               },
         fetchDriver() 
            {
               let url = "api/admin/driver/details?id=" + this.$route.params.id;         
               this.getToken();
               this.loading = true;
               this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  if(res.status == 200) 
                     {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.driver = responseData.drivers;
                        if(responseData.drivers.fuel_station)
                           {
                              this.driver.fuel_station_name = responseData.drivers.fuel_station.name_en;
                           }
                              else{
                                 this.driver.fuel_station_name = responseData.drivers.fuel_station_name_so;
                              }
                            this.fetchTrucks();
                        }  
                        })
               .catch((error) => {
                     console.log(error);
                     console.log(error.response);
                     if (error.response) {
                        if(error.response.status == 422) 
                           {               
                              if (error.response.data) 
                              {
                                 this.errors = error.response.data.message;
                              } 
                              this.$swal("", error.response.statusText, "error");
                              
                           } else if(error.response.status == 500) 
                              {
                                 this.$swal("", error.response.statusText, "error");
                              } else if(error.response.status == 401) 
                              {
                                 this.$swal("", error.response.statusText, "error");
                                 this.$router.push({ name: "login" });
                              } else {
                                  this.$swal("", "Something went wrong", "error");
                                    }
                     } else {
                        this.$swal("", error.message, "error");
                     }
            
               });
            //.finally(() => (this.loading = false));
            },
         fetchTrucks() 
               {  
                  let url = "api/admin/getFuelTrucks?fuel_station_id=" + this.driver.fuel_station_id;         
                  this.getToken();
                  this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                        var responseData = res.data.data;
                        console.log(responseData);
                        this.trucks = responseData.trucks;
                        var truck = {};
                        truck.id = this.driver.truck.id;
                        truck.truck_no = this.driver.truck.truck_no;
                        this.trucks.push(truck);

                              })
                     .catch((err) => console.log(err));
               },
         fetchCountryCodes() 
            {
               let url = "api/get-countrycodes";         
               this.getToken();
               this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                     var responseData = res.data.data;
                     console.log(responseData);
                     this.country_codes = responseData.country_codes;
                     console.warn(responseData.country_codes);

                           })
                  .catch((err) => console.log(err));
            },
         getToken() 
            {
            if (localStorage.getItem('sigofuel_admin')) 
                  {
                     var sigofuel_admin =  JSON.parse(localStorage.getItem('sigofuel_admin'));
                     if(sigofuel_admin.token) {
                        this.token = sigofuel_admin.token;
                        } else {
                              this.$swal("", "Failed to fetch token, please login again", "error");
                              this.$router.push({ name: "login" });
                              }
                  
                     } else {
                           this.$swal("", "Session expired, please login again", "error");
                           this.$router.push({ name: "login" });
                           }
            },
         
         setProfile(e)
           {
            this.profile_image = e.target.files[0];
            this.preview_profile_image = URL.createObjectURL(e.target.files[0]);
            },
         setLicense(e)
            {
               this.license_image = e.target.files[0];
               this.preview_license_image = URL.createObjectURL(e.target.files[0]);
            },
         setPassport(e) 
            {
               this.passport_image = e.target.files[0];
               this.preview_passport_image = URL.createObjectURL(e.target.files[0]);
            },

         updateDriver() 
         {
          this.getToken();
          const config = {
          headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
                   },
                  };

           let url = "api/admin/driver/update?id=" + this.$route.params.id;             
           let formData = new FormData();
            formData.append("name_en", this.driver.name_en);
            formData.append("name_so", this.driver.name_so);
            formData.append("mobile", this.driver.mobile); 
            // formData.append("email", this.driver.email);
            formData.append("country_code", this.driver.country_code_id); 
            formData.append("fuel_station", this.driver.fuel_station_id); 
            formData.append("truck", this.driver.truck_id); 
            formData.append("license_expiry", this.driver.license_expiry); 
            if(this.driver.email) 
               {
                  formData.append("email", this.driver.email);
               } else {
                  formData.append("email", '');
               }
            if(this.profile_image) 
               {
                  formData.append("image", this.profile_image); 
               }
            if(this.passport_image) 
               {
                  formData.append("passport", this.passport_image); 
               }
            if(this.license_expiry)
               {
                  formData.append("license", this.license_image); 
               }
          
             this.$axios
            .post(url, formData, config)
            .then((res) => {
                console.log(res);
                if(res.status == 200) 
                  {
                  this.$swal("", res.data.message, "success");
                 // this.clearForm();
                  this.$router.push({ name: 'drivers'});
                  }
                })
             .catch((error) => {
               console.log(error);
               console.log(error.response);
                  if (error.response) {
                     if(error.response.status == 422) {               
                        if (error.response.data) {
                           this.errors = error.response.data.message;
                              } 
                        this.$swal("", error.response.statusText, "error");
                  
                        } else if(error.response.status == 500) {
                           this.$swal("", error.response.statusText, "error");
                              } 
                        else if(error.response.status == 401) {
                           this.$swal("", error.response.statusText, "error");
                           this.$router.push({ name: "login" });
                              } else {
                                 this.$swal("", "Something went wrong", "error");
                              }
                     } else {
                           this.$swal("", error.message, "error");
                              }
            
               });
            //.finally(() => (this.loading = false));
               },
         
             }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'drivers' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  
                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light"> -->
                     <form class="form-horizontal" role="form" @submit.prevent="updateDriver()">
                           <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                              <div class="row">
                                 <b-form-group class="col-lg-6 mb-3">
                                    <label>Name (English) <span class="text-danger">*</span></label>
                                       <b-form-input v-model="driver.name_en" v-bind:class="{ 'is-invalid': Boolean(errors.name_en) }" @keypress="alphaSpacesOnly">
                                       </b-form-input>
                                    <div v-for="(val, index) in errors.name_en" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-form-group>
                              <b-form-group class="col-lg-4 mb-3">
                              <label>Name (Somali) <span class="text-danger">*</span></label>
                              <b-form-input v-model="driver.name_so" v-bind:class="{ 'is-invalid': Boolean(errors.name_so) }" @keypress="alphaSpacesOnly"></b-form-input>

                              <div v-for="(val, index) in errors.name_so" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                              </div>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Mobile <span class="text-danger">*</span></label>
                              <b-input-group>
                                 <b-input-group-prepend>
                                    <select class="form-control" v-model="driver.country_code_id">
                                       <option :value="country.id" v-for="country in country_codes" :key="country.id">{{country.country_code}}</option>
                                    </select>
                                 </b-input-group-prepend>
                                 <b-form-input v-model="driver.mobile" @keypress="numbersOnly" maxlength="15" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                 <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>
                           </b-form-group>

                           <b-form-group class="col-lg-6 mb-3">
                              <label>Email</label>
                              <b-form-input type="email" v-model="driver.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }" autocomplete="off"></b-form-input>
                                 <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                                 </b-form-group>

                                 <div class="form-group col-md-4">
                                 <label>Fuel Station <span class="text-danger">*</span></label>
                                 <input type="text" class="form-control" v-model="driver.fuel_station_name" disabled="disabled"/>

                                 </div>  

                                 <b-form-group class="col-lg-6 mb-3">
                              <label>Truck <span class="text-danger">*</span></label>

                                    <select class="form-control" v-model="driver.truck_id">
                                       <option :value="truck.id" v-for="truck in trucks" :key="truck.id">{{truck.truck_no}}</option>
                                    </select>

                           </b-form-group>                             
                              
                           </div>
                        </b-card>


                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Image & Documents</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Profile Image <span class="text-danger">*</span></label><br>
                                 <img v-if="driver.image" :src="$image_url + driver.image" class="avatar-sm mt-2 mb-2">
                                 <input type="file" @change="setProfile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }">
                                 <p class="small">Leave this field empty if you don't want to edit this field</p>

                                 <img  class="avatar-sm mt-2" :src="preview_profile_image">


                                 <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>
                           </div>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Passport <span class="text-danger">*</span></label>
                                 <a v-if="driver.passport_url" :href="$image_url + driver.passport_url" class="ms-3" target="_blank">View Passport</a>

                                 <input type="file" @change="setPassport($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.passport) }">
                                 <img v-if="preview_passport_image" class="avatar-sm mt-2" :src="preview_passport_image">
                                 
                                 <p class="small">Leave this field empty if you don't want to edit this field</p>
                              </div>
                           </div>
                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Driving License <span class="text-danger">*</span></label>
                                 <a v-if="driver.license_url" :href="$image_url + driver.license_url" class="ms-3" target="_blank">View License</a>

                                 <input type="file" @change="setLicense($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.license) }">
                                 <img v-if="preview_license_image" class="avatar-sm mt-2" :src="preview_license_image">
                                 
                                 <p class="small">Leave this field empty if you don't want to edit this field</p>
                              </div>
                           </div>
                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Driving License Expiry Date<span class="text-danger">*</span></label>
                                 <input type="date" class="form-control" v-model="driver.license_expiry" v-bind:class="{ 'is-invalid': Boolean(errors.license_expiry) }" :min="today">
                                 <div v-for="(val, index) in errors.license_expiry" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>
                           </div>
                        </b-card>                    


                        <div class="row mt-3">
                           <div class="12">
                              <button class="btn btn-primary me-2" type="submit">Save</button>
                              <router-link :to="{ name: 'drivers' }" class="btn btn-light">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  <!-- </b-card> -->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
